import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import React from 'react';
import QPRlogo from '../../../assets/QPR-logo-150px.png';
import LoginForm from './LoginForm';

const PREFIX = 'Login';

const classes = {
  paper: `${PREFIX}-paper`,
  containerPaper: `${PREFIX}-containerPaper`,
  form: `${PREFIX}-form`,
  submit: `${PREFIX}-submit`,
  logo: `${PREFIX}-logo`,
  inputRoot: `${PREFIX}-inputRoot`,
  focused: `${PREFIX}-focused`,
  error: `${PREFIX}-error`
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`& .${classes.containerPaper}`]: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  [`& .${classes.form}`]: {
    width: '100%', // Fix IE 11 issue.
    padding: theme.spacing(3, 0, 4, 0)
  },
  [`& .${classes.submit}`]: {
    margin: theme.spacing(1, 0, 0, 0),
    color: theme.palette.background.paper
  },
  [`& .${classes.paper}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  [`& .${classes.logo}`]: {
    marginTop: '20px'
  },
  [`& .${classes.inputRoot}`]: {
    backgroundColor: '#f3f4f5',
    '&.Mui-focused': {
      '& [class*="MuiSvgIcon-root"]': {
        color: theme.palette.primary.dark
      }
    },
    '&.Mui-error': {
      '& [class*="MuiSvgIcon-root"]': {
        color: 'red'
      }
    }
  },
  [`& .${classes.focused}`]: {},
  [`& .${classes.error}`]: {}
}));

interface QprLogin {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  errorMessage?: string;
}

const Login = ({ handleSubmit, errorMessage = '' }: QprLogin) => {
  return (
    <StyledContainer maxWidth="xs" data-testid="login-main">
      <Paper className={classes.containerPaper}>
        <LoginForm
          classes={classes}
          handleSubmit={handleSubmit}
          logo={QPRlogo}
          errorMessage={errorMessage}
          data-testid="login-form"
        />
      </Paper>
    </StyledContainer>
  );
};

export default Login;
